import React from 'react';
import {useTranslation} from 'react-i18next';
import {TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import {AlertModalPortal} from '../util/ModalPortalHelper';

const ConfirmPrivacyChangeModal: React.FC<IConfirmPrivacyChangeModalProps> = ({onClose, onConfirm, warnings}) => {
   const {t} = useTranslation();

   return (
      <AlertModalPortal
         testId="confirm-privacy-change-modal"
         title={t('confirmPrivacyChange.title')}
         onClose={onClose}
         onConfirm={onConfirm}
         confirmButtonType={TscButtonType.destructive}
         confirmContent={t('general.confirm')}
         onDismiss={onClose}
         dismissButtonType={TscButtonType.secondary}
         dismissContent={t('general.cancel')}
         modalWidth="30rem"
      >
         {t('confirmPrivacyChange.warning')}
         <ul>
            {warnings.map((message, index) => (
               <li
                  className="message"
                  key={`message-${index}`}
               >
                  {message}
               </li>
            ))}
         </ul>
      </AlertModalPortal>
   );
};

export default ConfirmPrivacyChangeModal;

interface IConfirmPrivacyChangeModalProps {
   onClose(): void;
   onConfirm(): void;
   warnings: string[];
}
